import { api } from './Api';

export const getWorkbooks = (integrationUid: string, keyword?: string) => {
  const params = keyword ? `?keyword=${encodeURIComponent(keyword)}` : '';

  return api.get(`integration/tableau/${integrationUid}/workbook${params}`).then((res: any) => res.data);
}

export const getViews = (integrationUid: string, workbookId: string, keyword?: string) => {
  const params = keyword ? `&keyword=${encodeURIComponent(keyword)}` : '';

  return api
    .get(`integration/tableau/${integrationUid}/view?workbook_id=${workbookId}${params}`)
    .then((res: any) => res.data);
}

export const getView = (integrationUid: string, viewId: string) => {
  return api.get(`integration/tableau/${integrationUid}/view/${viewId || 'no_id'}`)
    .then((res: any) => res.data);
}

export const getViewData = (integrationUid: string, viewId: string, action: string) => {
  return api.get(`integration/tableau/${integrationUid}/view/${viewId || 'no_id'}/${action}/data`)
    .then((res: any) => res.data);
}

export const getCustomViews = (integrationUid: string) => {
  return api.get(`integration/tableau/${integrationUid}/custom_view`)
      .then((res: any) => res.data);
}

export const getTrustedTicket = (integrationUid: string) => {
  return api.get(`integration/tableau/${integrationUid}/trusted_ticket`)
    .then((res: any) => res.data);
}

export const uploadThumbnail = (integrationUid: string, blockUid: string, workspaceId: string, startTime: string, file: any, onProgress: (progressEvent: ProgressEvent) => void) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('block_uid', blockUid);
  formData.append('workspace_id', workspaceId);
  formData.append('start_time', startTime);

  return api.post(`integration/tableau/${integrationUid}/upload_thumbnail`, formData, {
    onUploadProgress: onProgress,
  })
    .then((res: any) => res.data);
}
